import React from 'react';
import { connect } from 'react-redux';

import Link from './Link';

const Links = ({ data, width }) => (
    <div className='linkRow'>
        <div
            className="wrapper"
            style={{
                width: (data.length * (width > 536 ? 300 : 220)) + 'px'
            }}
        >
            {data.map(d => (
                <Link
                    {...d}
                    key={d.id}
                />
            ))}
        </div>
    </div>
);

const mapStateToProps = ({ main: { width } }) => ({
    width,
});

export default connect(mapStateToProps)(Links);
